import { memo } from "react";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { CommentRatings } from "@/components/ui/rating";
import { Label } from "@/components/ui/label";
import { FormFieldProps } from "./types";
import { Separator } from "@/components/ui/separator";

const RatingField = memo(({ config, control }: FormFieldProps) => {
  return (
    <>
      <FormField
        control={control}
        name={config.name}
        render={({ field }) => (
          <FormItem className={config.className}>
            <FormControl>
              <div className="flex flex-col gap-1">
                <Label
                  htmlFor={field.name}
                  className="text-slate-700 text-left text-sm font-medium font-['Raleway'] leading-normal"
                >
                  {config.label}
                </Label>
                <CommentRatings
                  rating={field.value ?? 0}
                  onRatingChange={field.onChange}
                />
              </div>
            </FormControl>
          </FormItem>
        )}
      />
      {config.separator && <Separator className="my-4" />}
    </>
  );
});

RatingField.displayName = "RatingField";
export default RatingField;
